import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Loader from "../../Loader/Loader";
import AuthenticatedLayout from "../AuthenticatedLayout/AuthenticatedLayout";

const PublicLayout = () => {
  return (
    <AuthenticatedLayout withSearch>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </AuthenticatedLayout>
  );
};

export default PublicLayout;